import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class Testimonial extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <div className="row align-items-center">
                                <div className="col-lg-6">
                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Help in the treatment of diabetics. reduce blood sugar levels Suitable for those who want to control blood sugar levels.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>V E E R A </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Reduces the risk of heart disease high blood pressure and obesity.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>M A D O N N A </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>It helps to increase food intake and helps reduce bitterness in food.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>J A N N I N </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Used as a sweetener instead of sugar. without causing high blood sugar</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>T A Y L O R </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Stevia herb to increase stamina.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>J O H N &nbsp; D O E </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>In addition to being used in food and beverages Nowadays, it is also being used as a sugar substitute in toothpaste production.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Orthi </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>in the food industry Stevia extract is considered to have many advantages such as not being degraded by microorganisms. When used with food, it does not cause spoilage.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>Jaffin </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <div className="rn-testimonial-content text-left">
                                            <div className="inner">
                                                <p>Stevia extract is used instead of sugar. or use it as a substitute for some sugar Because stevioside is resistant to acids and heat as well. Therefore, it can be used in a wide variety of food and beverages.</p>
                                            </div>
                                            <div className="author-info">
                                                <h6><span>JON CUMMINS </span> - H E A L T H &nbsp; P R O F E S S I O N A L</h6>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </div>
                                <div className="col-lg-6 mt_md--40 mt_sm--40">
                                    <TabList className="testimonial-thumb-wrapper">
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=10" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=20" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=30" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=40" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=50" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=60" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=7" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className="testimonial-thumbnai">
                                                <div className="thumb">
                                                    <img src="https://i.pravatar.cc/300?img=8" alt="Testimonial Images"/>
                                                </div>
                                            </div>
                                        </Tab>
                                    </TabList>
                                </div>
                            </div>
                        </Tabs>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Testimonial;